<template>
	<div
		v-if="isOpen"
		@click="$emit('close')"
		class="fixed top-0 left-0 z-3001 h-screen w-full bg-black/50"
	></div>
	<transition name="modal" @after-leave="$emit('runAfterLeave')">
		<dialog
			open
			v-if="isOpen"
			:class="{
				'top-0 bottom-0 bg-white p-0': !isSearch,
				'bottom-none top-32 bg-white p-0': isSearch,
				'p-0': isSolutionModal,
			}"
			class="z-99999 rounded-xl bg-black shadow-lg"
		>
			<slot> </slot>
		</dialog>
	</transition>
</template>

<script lang="js" src="./BaseDialog"></script>
